var map = {
	"./CampusPlatform/campus-platform-moduleA-icon1.png": 507,
	"./CampusPlatform/campus-platform-moduleA-icon10.png": 508,
	"./CampusPlatform/campus-platform-moduleA-icon11.png": 509,
	"./CampusPlatform/campus-platform-moduleA-icon12.png": 510,
	"./CampusPlatform/campus-platform-moduleA-icon13.png": 511,
	"./CampusPlatform/campus-platform-moduleA-icon14.png": 512,
	"./CampusPlatform/campus-platform-moduleA-icon15.png": 513,
	"./CampusPlatform/campus-platform-moduleA-icon16.png": 514,
	"./CampusPlatform/campus-platform-moduleA-icon2.png": 515,
	"./CampusPlatform/campus-platform-moduleA-icon3.png": 516,
	"./CampusPlatform/campus-platform-moduleA-icon4.png": 517,
	"./CampusPlatform/campus-platform-moduleA-icon5.png": 518,
	"./CampusPlatform/campus-platform-moduleA-icon6.png": 519,
	"./CampusPlatform/campus-platform-moduleA-icon7.png": 520,
	"./CampusPlatform/campus-platform-moduleA-icon8.png": 521,
	"./CampusPlatform/campus-platform-moduleA-icon9.png": 522,
	"./CampusPlatform/campus-platform-moduleA-img1.png": 523,
	"./CampusPlatform/campus-platform-moduleA-img2.png": 524,
	"./CampusPlatform/campus-platform-moduleB-icon1.png": 525,
	"./CampusPlatform/campus-platform-moduleB-icon10.png": 526,
	"./CampusPlatform/campus-platform-moduleB-icon11.png": 527,
	"./CampusPlatform/campus-platform-moduleB-icon12.png": 528,
	"./CampusPlatform/campus-platform-moduleB-icon13.png": 529,
	"./CampusPlatform/campus-platform-moduleB-icon14.png": 530,
	"./CampusPlatform/campus-platform-moduleB-icon15.png": 531,
	"./CampusPlatform/campus-platform-moduleB-icon16.png": 532,
	"./CampusPlatform/campus-platform-moduleB-icon17.png": 533,
	"./CampusPlatform/campus-platform-moduleB-icon18.png": 534,
	"./CampusPlatform/campus-platform-moduleB-icon19.png": 535,
	"./CampusPlatform/campus-platform-moduleB-icon2.png": 536,
	"./CampusPlatform/campus-platform-moduleB-icon20.png": 537,
	"./CampusPlatform/campus-platform-moduleB-icon21.png": 538,
	"./CampusPlatform/campus-platform-moduleB-icon22.png": 539,
	"./CampusPlatform/campus-platform-moduleB-icon23.png": 540,
	"./CampusPlatform/campus-platform-moduleB-icon24.png": 541,
	"./CampusPlatform/campus-platform-moduleB-icon25.png": 542,
	"./CampusPlatform/campus-platform-moduleB-icon26.png": 543,
	"./CampusPlatform/campus-platform-moduleB-icon27.png": 544,
	"./CampusPlatform/campus-platform-moduleB-icon28.png": 545,
	"./CampusPlatform/campus-platform-moduleB-icon29.png": 546,
	"./CampusPlatform/campus-platform-moduleB-icon3.png": 547,
	"./CampusPlatform/campus-platform-moduleB-icon30.png": 548,
	"./CampusPlatform/campus-platform-moduleB-icon31.png": 549,
	"./CampusPlatform/campus-platform-moduleB-icon32.png": 550,
	"./CampusPlatform/campus-platform-moduleB-icon33.png": 551,
	"./CampusPlatform/campus-platform-moduleB-icon4.png": 552,
	"./CampusPlatform/campus-platform-moduleB-icon5.png": 553,
	"./CampusPlatform/campus-platform-moduleB-icon6.png": 554,
	"./CampusPlatform/campus-platform-moduleB-icon7.png": 555,
	"./CampusPlatform/campus-platform-moduleB-icon8.png": 556,
	"./CampusPlatform/campus-platform-moduleB-icon9.png": 557,
	"./CampusPlatform/campus-platform-moduleB-img1.png": 558,
	"./CampusPlatform/campus-platform-moduleB-img2.png": 559,
	"./CampusPlatform/campus-platform-moduleB-img3.png": 560,
	"./CampusPlatform/campus-platform-moduleB-img4.png": 561,
	"./CampusPlatform/campus-platform-moduleB-img5.png": 138,
	"./CampusPlatform/campus-platform-moduleC-bg.png": 139,
	"./CampusPlatform/campus-platform-moduleD-icon1.png": 140,
	"./CampusPlatform/campus-platform-moduleD-icon2.png": 141,
	"./CampusPlatform/campus-platform-moduleE-icon1.png": 142,
	"./CampusPlatform/campus-platform-moduleE-icon10.png": 143,
	"./CampusPlatform/campus-platform-moduleE-icon2.png": 144,
	"./CampusPlatform/campus-platform-moduleE-icon3.png": 145,
	"./CampusPlatform/campus-platform-moduleE-icon4.png": 146,
	"./CampusPlatform/campus-platform-moduleE-icon5.png": 147,
	"./CampusPlatform/campus-platform-moduleE-icon6.png": 148,
	"./CampusPlatform/campus-platform-moduleE-icon7.png": 149,
	"./CampusPlatform/campus-platform-moduleE-icon8.png": 150,
	"./CampusPlatform/campus-platform-moduleE-icon9.png": 151,
	"./Dispatch_system/dispatch_systemmoduleA-icon1.png": 449,
	"./Dispatch_system/dispatch_systemmoduleA-icon10.png": 450,
	"./Dispatch_system/dispatch_systemmoduleA-icon11.png": 451,
	"./Dispatch_system/dispatch_systemmoduleA-icon12.png": 452,
	"./Dispatch_system/dispatch_systemmoduleA-icon13.png": 453,
	"./Dispatch_system/dispatch_systemmoduleA-icon14.png": 454,
	"./Dispatch_system/dispatch_systemmoduleA-icon15.png": 455,
	"./Dispatch_system/dispatch_systemmoduleA-icon2.png": 456,
	"./Dispatch_system/dispatch_systemmoduleA-icon3.png": 457,
	"./Dispatch_system/dispatch_systemmoduleA-icon4.png": 458,
	"./Dispatch_system/dispatch_systemmoduleA-icon5.png": 459,
	"./Dispatch_system/dispatch_systemmoduleA-icon6.png": 460,
	"./Dispatch_system/dispatch_systemmoduleA-icon7.png": 461,
	"./Dispatch_system/dispatch_systemmoduleA-icon8.png": 462,
	"./Dispatch_system/dispatch_systemmoduleA-icon9.png": 463,
	"./Dispatch_system/dispatch_systemmoduleA-img.png": 464,
	"./Dispatch_system/dispatch_systemmoduleA-map.png": 465,
	"./Dispatch_system/dispatch_systemmoduleC-icon1.png": 466,
	"./Dispatch_system/dispatch_systemmoduleC-icon2.png": 467,
	"./Dispatch_system/dispatch_systemmoduleC-icon3.png": 468,
	"./Dispatch_system/dispatch_systemmoduleC-icon4.png": 469,
	"./Dispatch_system/dispatch_systemmoduleC-icon5.png": 470,
	"./Dispatch_system/dispatch_systemmoduleC-icon6.png": 471,
	"./Dispatch_system/dispatch_systemmoduleC-icon7.png": 472,
	"./Dispatch_system/dispatch_systemmoduleC-icon8.png": 473,
	"./Dispatch_system/dispatch_systemmoduleC-img.png": 137,
	"./Dispatch_system/dispatch_systemmoduleD-img1.png": 474,
	"./Dispatch_system/dispatch_systemmoduleD-img2.png": 475,
	"./Dispatch_system/dispatch_systemmoduleD-img3.png": 476,
	"./Dispatch_system/dispatch_systemmoduleD-img4.png": 477,
	"./Dispatch_system/img-logical-system.png": 478,
	"./Emel.png": 650,
	"./about/about_part1.png": 362,
	"./about/about_part2.png": 363,
	"./about/about_part3.png": 364,
	"./about/aboutyili.png": 651,
	"./about/banner.png": 652,
	"./about/corporat-culture.png": 365,
	"./about/developing-cause-bgc.png": 361,
	"./about/developing-cause-content.png": 360,
	"./about/fa-envelope.png": 653,
	"./about/fa-map-marker.png": 654,
	"./about/fa-phone.png": 655,
	"./about/right.png": 366,
	"./aboutyili.2abff892.png": 656,
	"./admin.png": 657,
	"./backgroud_img/bg_index_3.png": 658,
	"./backgroud_img/img_process1.png": 164,
	"./backgroud_img/img_process2.png": 165,
	"./backgroud_img/img_process3.png": 166,
	"./backgroud_img/img_process4.png": 167,
	"./backgroud_img/img_process5.png": 168,
	"./backgroud_img/img_process6.png": 169,
	"./banner2.png": 659,
	"./banner_icon/ic_ free.png": 660,
	"./banner_icon/ic_Pay.png": 661,
	"./banner_icon/ic_address.png": 662,
	"./banner_icon/ic_foever.png": 663,
	"./banner_icon/ic_gift.png": 664,
	"./banner_icon/ic_ic_video.png": 665,
	"./banner_icon/ic_loction(1).png": 666,
	"./banner_icon/ic_loction.png": 667,
	"./banner_icon/ic_sale.png": 668,
	"./banner_icon/ic_search.png": 669,
	"./banner_icon/ic_share.png": 670,
	"./banner_icon/ic_store.png": 671,
	"./banner_icon/ic_system.png": 672,
	"./banner_icon/ic_time.png": 673,
	"./caselist/plate1-icon1.png": 354,
	"./caselist/plate1-icon2.png": 352,
	"./caselist/plate1-icon3.png": 353,
	"./caselist/plate1-icon4.png": 67,
	"./caselist/plate2-img1.png": 355,
	"./caselist/plate2-img2.png": 356,
	"./caselist/plate2-img3.png": 357,
	"./caselist/title1.png": 161,
	"./caselist/title2.png": 162,
	"./caselist/title3.png": 163,
	"./code.png": 674,
	"./comprehensive.png": 675,
	"./courier_app.png": 676,
	"./customized/blate1.png": 338,
	"./customized/blate2.png": 339,
	"./customized/blate3.png": 340,
	"./customized/blate3bg.png": 116,
	"./customized/blate4.png": 341,
	"./customized/blate5.png": 342,
	"./customized/blate6.png": 343,
	"./customized/ic_banner1.png": 344,
	"./customized/ic_banner2.png": 345,
	"./customized/ic_banner3.png": 346,
	"./customized/ic_banner4.png": 347,
	"./customized/icon1.png": 115,
	"./customized/icon2.png": 112,
	"./customized/icon3.png": 113,
	"./customized/icon4.png": 114,
	"./customized/icon7.png": 348,
	"./customized/icon8.png": 349,
	"./customized/icon9.png": 350,
	"./customized/img_bg_case.png": 84,
	"./customized/title1.png": 69,
	"./customized/title2.png": 62,
	"./customized/title3.png": 351,
	"./detaile/banner.png": 262,
	"./detaile/banner1.png": 263,
	"./detaile/banner2.png": 264,
	"./detaile/banner3.png": 265,
	"./detaile/ic_case_about1@2x(1).png": 266,
	"./detaile/ic_case_about1@2x(2).png": 267,
	"./detaile/ic_case_about1@2x(3).png": 268,
	"./detaile/ic_case_about1@2x.png": 269,
	"./detaile/icon-value-window1.png": 90,
	"./detaile/icon-value-window2.png": 91,
	"./detaile/icon-value-window3.png": 92,
	"./detaile/icon-value-window4.png": 93,
	"./detaile/icon-value-window5.png": 94,
	"./detaile/icon-value-window6.png": 95,
	"./detaile/icon_functions(4)4.png": 270,
	"./detaile/icon_functions(4)8.png": 271,
	"./detaile/icon_functions(4)9.png": 272,
	"./detaile/icon_functions10.png": 273,
	"./detaile/icon_functions2.png": 274,
	"./detaile/icon_functions3.png": 275,
	"./detaile/icon_functions8 (1).png": 276,
	"./detaile/icon_functions8.png": 277,
	"./detaile/icon_functions9.png": 278,
	"./detaile/icon_left.png": 96,
	"./detaile/icon_perfect1.png": 279,
	"./detaile/icon_perfect2.png": 280,
	"./detaile/icon_perfect3.png": 281,
	"./detaile/icon_perfect4.png": 282,
	"./detaile/icon_perfect5.png": 283,
	"./detaile/icon_perfect6.png": 284,
	"./detaile/icon_right.png": 97,
	"./detaile/icon_template1.png": 285,
	"./detaile/icon_template2.png": 286,
	"./detaile/icon_template3.png": 287,
	"./detaile/icon_template4.png": 288,
	"./detaile/icon_template5.png": 289,
	"./detaile/icon_template6.png": 290,
	"./detaile/img-scope1.png": 291,
	"./detaile/img-scope2.png": 292,
	"./detaile/img-scope3.png": 293,
	"./detaile/img-scope4.png": 294,
	"./detaile/img-scope5.png": 295,
	"./detaile/img-scope6.png": 296,
	"./detaile/img-scope7.png": 297,
	"./detaile/img-value-window.png": 98,
	"./detaile/img_border.png": 99,
	"./detaile/img_system1.png": 298,
	"./detaile/img_system2.png": 299,
	"./detaile/img_system3.png": 300,
	"./detaile/img_system4.png": 301,
	"./detaile/img_system5.png": 302,
	"./detaile/img_system6.png": 303,
	"./detaile/img_template.png": 304,
	"./detaile/order_icon1.png": 305,
	"./detaile/order_icon10.png": 306,
	"./detaile/order_icon11.png": 307,
	"./detaile/order_icon12.png": 308,
	"./detaile/order_icon13.png": 309,
	"./detaile/order_icon14.png": 310,
	"./detaile/order_icon15.png": 311,
	"./detaile/order_icon16.png": 312,
	"./detaile/order_icon17.png": 313,
	"./detaile/order_icon18.png": 314,
	"./detaile/order_icon19.png": 315,
	"./detaile/order_icon2.png": 316,
	"./detaile/order_icon20.png": 317,
	"./detaile/order_icon21.png": 318,
	"./detaile/order_icon22.png": 319,
	"./detaile/order_icon23.png": 320,
	"./detaile/order_icon24.png": 321,
	"./detaile/order_icon25.png": 322,
	"./detaile/order_icon26.png": 323,
	"./detaile/order_icon27.png": 324,
	"./detaile/order_icon28.png": 325,
	"./detaile/order_icon29.png": 326,
	"./detaile/order_icon3.png": 327,
	"./detaile/order_icon30.png": 328,
	"./detaile/order_icon31.png": 329,
	"./detaile/order_icon32.png": 330,
	"./detaile/order_icon4.png": 331,
	"./detaile/order_icon5.png": 332,
	"./detaile/order_icon6.png": 333,
	"./detaile/order_icon7.png": 334,
	"./detaile/order_icon8.png": 335,
	"./detaile/order_icon9.png": 336,
	"./detaile/service-scenario-bg.png": 337,
	"./detaile/service-scenario-bg1.png": 100,
	"./detaile/service-scenario-bg2.png": 101,
	"./detaile/service-scenario-bg3.png": 102,
	"./detaile/service-scenario-bg4.png": 103,
	"./detaile/service-scenario-bg5.png": 104,
	"./detaile/service-scenario-bg6.png": 105,
	"./detaile/service-scenario-icon1.png": 106,
	"./detaile/service-scenario-icon2.png": 107,
	"./detaile/service-scenario-icon3.png": 108,
	"./detaile/service-scenario-icon4.png": 109,
	"./detaile/service-scenario-icon5.png": 110,
	"./detaile/service-scenario-icon6.png": 111,
	"./dou.png": 175,
	"./downloadCenter/h5-user-code.png": 481,
	"./downloadCenter/icon-download-center1.png": 479,
	"./downloadCenter/icon-download-center2.png": 480,
	"./downloadCenter/icon-download-center3.png": 482,
	"./downloadCenter/icon-download-center4.png": 483,
	"./downloadCenter/icon-download-center5.png": 484,
	"./downloadCenter/icon-download-center6.png": 485,
	"./downloadCenter/icon-download-center7.png": 486,
	"./downloadCenter/icon-download-center8.png": 487,
	"./downloadCenter/img-download-center1.png": 677,
	"./downloadCenter/img-download-center2.png": 678,
	"./downloadCenter/img-download-center3.png": 679,
	"./downloadCenter/img-download-center4.png": 680,
	"./foooter_code.png": 681,
	"./foooter_code2.png": 682,
	"./footer/foooter_code1.png": 176,
	"./headerIcon1.png": 683,
	"./headerIcon2 2.png": 684,
	"./headerIcon2.png": 685,
	"./homeIcon/arrows_down.png": 686,
	"./homeIcon/certifications.png": 88,
	"./homeIcon/cooperative-partnerA.png": 85,
	"./homeIcon/cooperative-partnerB.png": 86,
	"./homeIcon/cooperative-partnerC.png": 87,
	"./homeIcon/ic_delivery.png": 687,
	"./homeIcon/ic_delivery_hover.png": 688,
	"./homeIcon/ic_life.png": 689,
	"./homeIcon/ic_life_hover.png": 690,
	"./homeIcon/ic_process1.png": 691,
	"./homeIcon/ic_process2.png": 692,
	"./homeIcon/ic_process3.png": 693,
	"./homeIcon/ic_process4.png": 694,
	"./homeIcon/ic_process5.png": 695,
	"./homeIcon/ic_process6.png": 696,
	"./homeIcon/ic_services1.png": 697,
	"./homeIcon/ic_services2.png": 698,
	"./homeIcon/ic_services3.png": 699,
	"./homeIcon/ic_services4.png": 700,
	"./homeIcon/ic_services5.png": 701,
	"./homeIcon/ic_services6.png": 702,
	"./homeIcon/ic_services7.png": 703,
	"./homeIcon/ic_services8.png": 704,
	"./homeIcon/ic_services9.png": 705,
	"./homeIcon/icon-O2O-system1.png": 254,
	"./homeIcon/icon-O2O-system2.png": 255,
	"./homeIcon/icon-O2O-system3.png": 256,
	"./homeIcon/icon-O2O-system4.png": 257,
	"./homeIcon/icon-O2O-system5.png": 258,
	"./homeIcon/icon-O2O-system6.png": 259,
	"./homeIcon/icon-home-tag1.png": 209,
	"./homeIcon/icon-home-tag2.png": 210,
	"./homeIcon/icon-home-tag3.png": 206,
	"./homeIcon/icon-home-tag4.png": 207,
	"./homeIcon/icon-home-tag5.png": 208,
	"./homeIcon/icon-home-tag6.png": 211,
	"./homeIcon/icon-tag-moduleA1.png": 212,
	"./homeIcon/icon-tag-moduleA2.png": 213,
	"./homeIcon/icon-tag-moduleA3.png": 214,
	"./homeIcon/icon-tag-moduleA4.png": 215,
	"./homeIcon/icon-tag-moduleA5.png": 216,
	"./homeIcon/icon-tag-moduleB1.png": 217,
	"./homeIcon/icon-tag-moduleB2.png": 218,
	"./homeIcon/icon-tag-moduleB3.png": 219,
	"./homeIcon/icon-tag-moduleB4.png": 220,
	"./homeIcon/icon-tag-moduleB5.png": 221,
	"./homeIcon/icon-tag-moduleC1.png": 222,
	"./homeIcon/icon-tag-moduleC2.png": 223,
	"./homeIcon/icon-tag-moduleC3.png": 224,
	"./homeIcon/icon-tag-moduleC4.png": 225,
	"./homeIcon/icon-tag-moduleD1.png": 226,
	"./homeIcon/icon-tag-moduleD2.png": 227,
	"./homeIcon/icon-tag-moduleD3.png": 228,
	"./homeIcon/icon-tag-moduleD4.png": 229,
	"./homeIcon/icon-tag-moduleE1.png": 230,
	"./homeIcon/icon-tag-moduleE2.png": 231,
	"./homeIcon/icon-tag-moduleE3.png": 232,
	"./homeIcon/icon-tag-moduleE4.png": 233,
	"./homeIcon/icon-tag-moduleF1.png": 706,
	"./homeIcon/icon-tag-moduleF2.png": 707,
	"./homeIcon/icon-tag-moduleF3.png": 708,
	"./homeIcon/icon-tag-moduleF4.png": 709,
	"./homeIcon/icon-tag-moduleF5.png": 710,
	"./homeIcon/icon1.png": 711,
	"./homeIcon/icon2.png": 712,
	"./homeIcon/icon3.png": 713,
	"./homeIcon/icon4.png": 714,
	"./homeIcon/icon5.png": 715,
	"./homeIcon/icon6.png": 716,
	"./homeIcon/icon7.png": 717,
	"./homeIcon/icon8.png": 718,
	"./homeIcon/icon9.png": 719,
	"./homeIcon/icon_applet.png": 720,
	"./homeIcon/icon_arrows_down.png": 721,
	"./homeIcon/icon_browse@2x.png": 261,
	"./homeIcon/icon_qq.png": 722,
	"./homeIcon/icon_right_arrow.png": 723,
	"./homeIcon/icon_teach.png": 724,
	"./homeIcon/icon_time@2x.png": 260,
	"./homeIcon/icon_trumpet.png": 205,
	"./homeIcon/img-tag-moduleA1.png": 725,
	"./homeIcon/img-tag-moduleB1.png": 726,
	"./homeIcon/img-tag-moduleC1.png": 727,
	"./homeIcon/img-tag-moduleD1.png": 728,
	"./homeIcon/img-tag-moduleE1.png": 729,
	"./homeIcon/img-tag-moduleF1.png": 730,
	"./homeIcon/img_code_cc.png": 731,
	"./homeIcon/img_code_fz.png": 732,
	"./homeIcon/img_delivery.png": 733,
	"./homeIcon/img_delivery2.png": 734,
	"./homeIcon/img_life.png": 735,
	"./homeIcon/img_life2.png": 736,
	"./homeIcon/img_online.png": 737,
	"./homeIcon/phone1.png": 738,
	"./homeIcon/phone2.png": 739,
	"./homeIcon/phone3.png": 740,
	"./homeIcon/phone4.png": 741,
	"./homeIcon/phone5.png": 742,
	"./homeIcon/phone6.png": 743,
	"./homeIcon/phone7.png": 744,
	"./homeIcon/phone8.png": 745,
	"./homeIcon/rowLeft.png": 746,
	"./homeIcon/rowRight.png": 747,
	"./homeIcon/rowTop.png": 748,
	"./homeIcon/tec_icon_2.png": 749,
	"./homeIcon/tec_icon_3.png": 750,
	"./homeIcon/tec_icon_4.png": 751,
	"./homeIcon/user-wechat.png": 155,
	"./homeIcon/weixin.png": 752,
	"./homePlate2Icon1.png": 753,
	"./homePlate2Icon2.png": 754,
	"./homePlate2Icon3.png": 755,
	"./homePlate2Icon4.png": 756,
	"./homePlate3Bg.png": 757,
	"./homePlatesIcon5.png": 758,
	"./homeTitle1.png": 759,
	"./homeTitle2.png": 760,
	"./homeTitle3.png": 761,
	"./homeTitle4.png": 158,
	"./homeTitle5.png": 159,
	"./homeTitle6.png": 160,
	"./home_phone1.png": 170,
	"./home_phone2.png": 171,
	"./home_phone3.png": 172,
	"./home_phone4.png": 173,
	"./ic_banner1.png": 762,
	"./ic_banner2.png": 763,
	"./ic_banner3.png": 764,
	"./ic_banner4.png": 765,
	"./icon-head-download.png": 766,
	"./icon-head-lyt.png": 767,
	"./icon-head-product.png": 768,
	"./icon-head-serve.png": 769,
	"./icon-head-terrace.png": 770,
	"./icon/icon1.png": 234,
	"./icon/icon10.png": 235,
	"./icon/icon11.png": 236,
	"./icon/icon12.png": 237,
	"./icon/icon2.png": 238,
	"./icon/icon3.png": 239,
	"./icon/icon4.png": 240,
	"./icon/icon5.png": 241,
	"./icon/icon6.png": 242,
	"./icon/icon7.png": 243,
	"./icon/icon8.png": 244,
	"./icon/icon9.png": 245,
	"./icon/zu12(1).png": 246,
	"./icon/zu12(1)sel.png": 247,
	"./icon/zu12(2).png": 248,
	"./icon/zu12(2)sel.png": 249,
	"./icon/zu12(3).png": 250,
	"./icon/zu12(3)sel.png": 251,
	"./icon/zu12(4).png": 252,
	"./icon/zu12(4)sel.png": 253,
	"./icon_nav_life.png": 771,
	"./icon_nav_run.png": 772,
	"./img_ text_profit.png": 156,
	"./img_code_2.png": 773,
	"./img_functions.png": 774,
	"./img_text_benchmarking.png": 157,
	"./img_text_highlights.png": 775,
	"./information/banner.png": 776,
	"./information/icon1.png": 117,
	"./information/icon2.png": 358,
	"./information/icon3.png": 359,
	"./logo.png": 777,
	"./logo1.png": 778,
	"./logo2.png": 174,
	"./logoName.png": 779,
	"./ma.png": 177,
	"./ma2.png": 178,
	"./ma3.png": 179,
	"./ma4.png": 180,
	"./merchant_app.png": 780,
	"./multiPlatform/multi-platform-moduleA.png": 781,
	"./multiPlatform/multi-platform-moduleB.png": 782,
	"./multiPlatform/multi-platform-moduleC1.png": 783,
	"./multiPlatform/multi-platform-moduleC2.png": 784,
	"./multiPlatform/multi-platform-moduleC3.png": 785,
	"./multiPlatform/multi-platform-moduleC4.png": 786,
	"./multiPlatform/multi-platform-moduleD1.png": 787,
	"./multiPlatform/multi-platform-moduleD2.png": 788,
	"./multiPlatform/multi-platform-moduleD3.png": 789,
	"./multiPlatform/multi-platform-moduleD4.png": 790,
	"./multiPlatform/multi-platform-moduleD5.png": 791,
	"./multiPlatform/multi-platform-moduleD6.png": 792,
	"./multiPlatform/multi-platform-moduleD7.png": 793,
	"./multiPlatform/multi-platform-moduleE.png": 794,
	"./notJust.png": 61,
	"./perfectSystem.png": 795,
	"./phone.png": 796,
	"./phone2.png": 797,
	"./phone3.png": 798,
	"./phone4.png": 799,
	"./position.png": 800,
	"./self/banner.png": 801,
	"./self/plate2Img1.png": 562,
	"./self/plate2Img2.png": 563,
	"./self/plate2Img3.png": 802,
	"./self/plate2Img4.png": 803,
	"./self/plate2Img5.png": 804,
	"./self/plate3Img1.png": 564,
	"./self/plate4Img1.png": 565,
	"./self/record.png": 566,
	"./service/bg-service-modulesC.png": 489,
	"./service/bg-service-modulesD1.png": 490,
	"./service/bg-service-modulesD2.png": 491,
	"./service/bg-service-modulesD3.png": 492,
	"./service/bg-service-modulesD4.png": 493,
	"./service/bg-service-modulesD5.png": 494,
	"./service/bg-service-modulesD6.png": 495,
	"./service/bg-service-modulesD7.png": 496,
	"./service/bg-service-modulesD8.png": 497,
	"./service/black-triangle.png": 498,
	"./service/icon-service-modulesA1.png": 499,
	"./service/icon-service-modulesA2.png": 500,
	"./service/icon-service-modulesA3.png": 501,
	"./service/icon-service-modulesA4.png": 502,
	"./service/icon-service-modulesB1.png": 503,
	"./service/icon-service-modulesB2.png": 504,
	"./service/icon-service-modulesB3.png": 505,
	"./service/yellow-triangle.png": 506,
	"./shopping/Macbook1.png": 805,
	"./shopping/Macbook2.png": 806,
	"./shopping/Macbook3.png": 807,
	"./shopping/Macbook4.png": 808,
	"./shopping/Macbook5.png": 809,
	"./shopping/banner.png": 810,
	"./shopping/icon1.png": 811,
	"./shopping/icon2.png": 812,
	"./shopping/icon3.png": 813,
	"./shopping/icon4.png": 814,
	"./shopping/icon5.png": 815,
	"./shopping/plate2Bg.png": 816,
	"./shopping/plate2_icon1.png": 817,
	"./shopping/plate2_icon2.png": 818,
	"./shopping/plate2_icon3.png": 819,
	"./shopping/plate2_icon4.png": 820,
	"./shopping/plate2_icon5.png": 821,
	"./shopping/plate2_icon6.png": 822,
	"./shopping/plate4_icon1.png": 823,
	"./shopping/plate4_icon2.png": 824,
	"./shopping/plate4_icon3.png": 825,
	"./shopping/plate4_icon4.png": 826,
	"./shopping/plate4_icon5.png": 827,
	"./shopping/plate4_icon6.png": 828,
	"./shopping/plate4_icon7.png": 829,
	"./shopping/plate4_icon8.png": 830,
	"./shopping/plate5-icon1.png": 831,
	"./shopping/plate5_phone.png": 832,
	"./shopping/title1.png": 833,
	"./shopping/title2.png": 834,
	"./shopping/title3.png": 835,
	"./shopping/title4.png": 836,
	"./slider_icon1-1.png": 837,
	"./slider_icon1-2.png": 838,
	"./slider_icon2-1.png": 839,
	"./slider_icon2-2.png": 840,
	"./slider_icon3-1.png": 841,
	"./slider_icon3-2.png": 842,
	"./slider_icon4-1.png": 843,
	"./slider_icon4-2.png": 844,
	"./slider_icon5-1.png": 845,
	"./slider_icon5-2.png": 846,
	"./systemoto/icon-plusSign.png": 68,
	"./systemoto/system-oto-modulesA-img.png": 847,
	"./systemoto/system-oto-modulesB-bg.png": 136,
	"./systemoto/system-oto-modulesB-img.png": 568,
	"./systemoto/system-oto-modulesC-icon1.png": 569,
	"./systemoto/system-oto-modulesC-icon2.png": 570,
	"./systemoto/system-oto-modulesC-icon3.png": 152,
	"./systemoto/system-oto-modulesC-icon4.png": 571,
	"./systemoto/system-oto-modulesC-img.png": 848,
	"./systemoto/system-oto-modulesD-icon1.png": 572,
	"./systemoto/system-oto-modulesD-icon10.png": 573,
	"./systemoto/system-oto-modulesD-icon11.png": 574,
	"./systemoto/system-oto-modulesD-icon12.png": 575,
	"./systemoto/system-oto-modulesD-icon13.png": 576,
	"./systemoto/system-oto-modulesD-icon14.png": 577,
	"./systemoto/system-oto-modulesD-icon15.png": 578,
	"./systemoto/system-oto-modulesD-icon16.png": 579,
	"./systemoto/system-oto-modulesD-icon161.png": 849,
	"./systemoto/system-oto-modulesD-icon2.png": 580,
	"./systemoto/system-oto-modulesD-icon3.png": 581,
	"./systemoto/system-oto-modulesD-icon4.png": 582,
	"./systemoto/system-oto-modulesD-icon5.png": 583,
	"./systemoto/system-oto-modulesD-icon6.png": 584,
	"./systemoto/system-oto-modulesD-icon7.png": 585,
	"./systemoto/system-oto-modulesD-icon8.png": 586,
	"./systemoto/system-oto-modulesD-icon9.png": 587,
	"./systemoto/system-oto-modulesD-img.png": 850,
	"./systemoto/system-oto-modulesE-icon1.png": 588,
	"./systemoto/system-oto-modulesE-icon2.png": 589,
	"./systemoto/system-oto-modulesE-icon3.png": 590,
	"./systemoto/system-oto-modulesE-icon4.png": 591,
	"./systemoto/system-oto-modulesE-icon5.png": 592,
	"./systemoto/system-oto-modulesE-icon6.png": 593,
	"./systemoto/system-oto-modulesE-icon8.png": 594,
	"./systemoto/system-oto-modulesE-icon9.png": 595,
	"./systemoto/system-oto-modulesE-img.png": 851,
	"./systemoto/system-oto-modulesF-icon1.png": 596,
	"./systemoto/system-oto-modulesF-icon2.png": 597,
	"./systemoto/system-oto-modulesF-icon3.png": 598,
	"./systemoto/system-oto-modulesF-icon4.png": 599,
	"./systemoto/system-oto-modulesF-icon5.png": 600,
	"./systemoto/system-oto-modulesF-icon6.png": 601,
	"./systemoto/system-oto-modulesF-img.png": 602,
	"./takeOutFood/ic_highlights1.png": 368,
	"./takeOutFood/ic_highlights10.png": 369,
	"./takeOutFood/ic_highlights11.png": 370,
	"./takeOutFood/ic_highlights12.png": 371,
	"./takeOutFood/ic_highlights2.png": 372,
	"./takeOutFood/ic_highlights3.png": 373,
	"./takeOutFood/ic_highlights4.png": 374,
	"./takeOutFood/ic_highlights5.png": 375,
	"./takeOutFood/ic_highlights6.png": 376,
	"./takeOutFood/ic_highlights7.png": 377,
	"./takeOutFood/ic_highlights8.png": 378,
	"./takeOutFood/ic_highlights9.png": 379,
	"./takeOutFood/icon-moduleA1.png": 118,
	"./takeOutFood/icon-moduleA2.png": 119,
	"./takeOutFood/icon-moduleA3.png": 120,
	"./takeOutFood/icon-moduleC1.png": 121,
	"./takeOutFood/icon-moduleC10.png": 132,
	"./takeOutFood/icon-moduleC11.png": 133,
	"./takeOutFood/icon-moduleC12.png": 134,
	"./takeOutFood/icon-moduleC2.png": 122,
	"./takeOutFood/icon-moduleC3.png": 123,
	"./takeOutFood/icon-moduleC4.png": 124,
	"./takeOutFood/icon-moduleC5.png": 126,
	"./takeOutFood/icon-moduleC6.png": 127,
	"./takeOutFood/icon-moduleC7.png": 128,
	"./takeOutFood/icon-moduleC8.png": 129,
	"./takeOutFood/icon-moduleC9.png": 131,
	"./takeOutFood/icon-moduleE1.png": 380,
	"./takeOutFood/icon-moduleE10.png": 381,
	"./takeOutFood/icon-moduleE2.png": 382,
	"./takeOutFood/icon-moduleE3.png": 383,
	"./takeOutFood/icon-moduleE4.png": 384,
	"./takeOutFood/icon-moduleE5.png": 385,
	"./takeOutFood/icon-moduleE6.png": 386,
	"./takeOutFood/icon-moduleE7.png": 387,
	"./takeOutFood/icon-moduleE8.png": 388,
	"./takeOutFood/icon-moduleE9.png": 389,
	"./takeOutFood/icon_Benchmarking101.png": 390,
	"./takeOutFood/icon_Benchmarking102.png": 391,
	"./takeOutFood/icon_Benchmarking103.png": 392,
	"./takeOutFood/icon_Benchmarking104.png": 393,
	"./takeOutFood/icon_Benchmarking105.png": 394,
	"./takeOutFood/icon_Benchmarking106.png": 395,
	"./takeOutFood/icon_Benchmarking201.png": 396,
	"./takeOutFood/icon_Benchmarking202.png": 397,
	"./takeOutFood/icon_Benchmarking203.png": 398,
	"./takeOutFood/icon_Benchmarking204.png": 399,
	"./takeOutFood/icon_Benchmarking205.png": 400,
	"./takeOutFood/icon_Benchmarking206.png": 401,
	"./takeOutFood/icon_Benchmarking301.png": 402,
	"./takeOutFood/icon_Benchmarking302.png": 403,
	"./takeOutFood/icon_Benchmarking303.png": 404,
	"./takeOutFood/icon_Benchmarking304.png": 405,
	"./takeOutFood/icon_Benchmarking305.png": 406,
	"./takeOutFood/icon_Benchmarking306.png": 407,
	"./takeOutFood/icon_Benchmarking401.png": 408,
	"./takeOutFood/icon_Benchmarking402.png": 409,
	"./takeOutFood/icon_Benchmarking403.png": 410,
	"./takeOutFood/icon_Benchmarking404.png": 411,
	"./takeOutFood/icon_Benchmarking405.png": 412,
	"./takeOutFood/icon_Benchmarking406.png": 413,
	"./takeOutFood/img-moduleB1.png": 414,
	"./takeOutFood/img-moduleB2.png": 415,
	"./takeOutFood/img-moduleB3.png": 416,
	"./takeOutFood/img-moduleB4.png": 417,
	"./takeOutFood/img-moduleB5.png": 418,
	"./takeOutFood/img-moduleC1.png": 125,
	"./takeOutFood/img-moduleC2.png": 130,
	"./takeOutFood/img-moduleC3.png": 135,
	"./takeOutFood/img_Benchmarking101.png": 419,
	"./takeOutFood/img_Benchmarking102.png": 420,
	"./takeOutFood/img_Benchmarking103.png": 421,
	"./takeOutFood/img_Benchmarking104.png": 422,
	"./takeOutFood/img_Benchmarking105.png": 423,
	"./takeOutFood/img_Benchmarking106.png": 424,
	"./takeOutFood/img_Benchmarking201.png": 425,
	"./takeOutFood/img_Benchmarking202.png": 426,
	"./takeOutFood/img_Benchmarking203.png": 427,
	"./takeOutFood/img_Benchmarking204.png": 428,
	"./takeOutFood/img_Benchmarking205.png": 429,
	"./takeOutFood/img_Benchmarking206.png": 430,
	"./takeOutFood/img_Benchmarking301.png": 431,
	"./takeOutFood/img_Benchmarking302.png": 432,
	"./takeOutFood/img_Benchmarking303.png": 433,
	"./takeOutFood/img_Benchmarking304.png": 434,
	"./takeOutFood/img_Benchmarking305.png": 435,
	"./takeOutFood/img_Benchmarking306.png": 436,
	"./takeOutFood/img_Benchmarking401.png": 437,
	"./takeOutFood/img_Benchmarking402.png": 438,
	"./takeOutFood/img_Benchmarking403.png": 439,
	"./takeOutFood/img_Benchmarking404.png": 440,
	"./takeOutFood/img_Benchmarking405.png": 441,
	"./takeOutFood/img_Benchmarking406.png": 442,
	"./takeOutFood/img_join1.png": 443,
	"./takeOutFood/img_join2.png": 444,
	"./takeOutFood/img_join3.png": 445,
	"./takeOutFood/img_join4.png": 446,
	"./takeOutFood/img_join5.png": 447,
	"./takeOutFood/img_join6.png": 448,
	"./title2.png": 852,
	"./title3.png": 853,
	"./tou.png": 181,
	"./weChatCode.png": 603,
	"./wei.png": 182,
	"./xiazai.png": 854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 567;